function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m58.04248 46.769c-.04467-.05472-8.38567-7.94188-8.43908-7.99669a5.91476 5.91476 0 0 0 -8.14493.98307c-4.26864 5.35191-13.93522-4.63685-17.74558-11.07183-2.00832-4.47441.80123-6.21855 1.04051-6.436 3.34035-3.11619 2.20851-6.59227 1.09767-8.05027l-7.62841-8.67189c-4.86457-4.87439-11.12666 3.26135-11.99605 4.7643-7.29551 11.39 11.70967 31.56516 13.22064 33.17858.81736 1.00055 22.08128 22.2 33.38825 15.10869 1.4655-.78716 9.92965-6.74738 5.20698-11.80796zm-.63428 3.8335c-.39355 2.62891-4.17285 5.40723-5.5957 6.25586-10.147 6.04443-29.6748-13.5083-30.87207-14.72363-.28743-.30083-19.56216-20.47916-13.03433-30.76031.89663-1.3876 3.80288-5.0546 6.45425-5.35489a2.89625 2.89625 0 0 1 2.41406.88281l7.52491 8.5542c.19873.27 1.852 2.6958-.85254 5.27442-1.522 1.04-3.70264 4.12744-1.522 8.84668a30.031 30.031 0 0 0 2.97313 4.28221 32.34206 32.34206 0 0 0 9.29982 8.34962c4.58155 2.32569 7.74366.26123 8.83789-1.22217 2.68506-2.60644 5.04444-.87109 5.24659-.71484l8.30224 7.86621a2.91013 2.91013 0 0 1 .82375 2.46387z",
  fill: "rgb(0,0,0)"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "line",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.670becc6.svg";
export { ForwardRef as ReactComponent };